import React, { Component } from 'react'
import { Row, Field, Label }  from '../../generic'
import TextInput from '../../generic/fields/TextInput'
import DatePicker from '../../generic/fields/DatePicker'

class When extends Component {
  render() {
    const { userEvent, onChange } = this.props
    return (
      <React.Fragment>
        <Row>
          <h2 style={{marginBottom: '20px'}}>Event Date and Time</h2>
          <p>Most events will happen on Thursday, September 26th, but you can host yours any time up to October 3rd.</p>
          <Field name="userEvent[invitation_date]" error={false}>
            <Label value="Event Date" required={true} />
            <DatePicker value={userEvent.invitation_date} onChange={onChange} />
          </Field>
          <Field name="userEvent[invitation_start_time]" error={false} hint="E.g. 2pm to 5pm, Noon to 3, Dawn to dusk">
            <Label value="Start and End Time" required={true} />
            <TextInput value={userEvent.invitation_start_time} onChange={onChange} />
          </Field>
        </Row>
      </React.Fragment>
    )
  }
}

export default When
